<section>
    <div id="slider">
        <div id="headerSlider" class="carousel slide" data-ride="carousel">
            <!-- <ol class="carousel-indicators">
          <li data-target="#headerSlider" data-slide-to="0" class="active"></li>
  
        </ol> -->
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <img
                        src="../assets/images/banner1.jpg"
                        class="d-block w-100"
                    />
                    <div class="carousel-caption">
                        <div class="banner-text">
                            <!-- <h4 class="">Our Three Pillars</h4> -->
                            <!-- <h5>STRIDE &middot; STRIVE &middot; SOAR</h5> -->
                            <h2>Listing</h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section id="property-details">
    <div class="container">
        <h1 class="heading text-center">Property Details</h1>
        <div class="row">
            <div class="col-lg-9 img-fluid">
                <img class="main-property-img" [src]="images_array[0]?.path" (click)="showGallery(0)" alt="">
                <div class="main-details">
                    <div class="details">
                        <p class="the-label-detail">
                            Address
                        </p>
                        <p class="the-actual-detail">
                            {{listing_details[0]?.address?.full + ', ' + listing_details[0]?.address?.city + ', ' + listing_details[0]?.address?.state }}
                        </p>
                    </div>
                    <div class="details d-none d-sm-none d-md-none d-lg-none d-xl-block">
                        <p class="the-label-detail">
                            Type
                        </p>                        
                        <p class="the-actual-detail">
                            {{listing_details[0]?.property?.subType}}
                        </p>
                        
                    </div>
                    <div class="details">
                        <p class="the-label-detail">
                            Price
                        </p>
                        <p class="the-actual-detail price">
                            {{getPrice(listing_details[0]?.listPrice)}}
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-5 property-attributes">
                        <p class="the-label-detail">
                            Property Attributes
                        </p>
                        <!-- Property Attributes Start Here -->
                        <div class="attributes">
                            <div class="attribute-name">
                                MLS#
                                
                            </div>
                            <div class="attribute-value">
                                {{listing_details[0]?.mlsId}}
                            </div>
                        </div>
                        <div class="attributes">
                            <div class="attribute-name">
                                County
                                
                            </div>
                            <div class="attribute-value">
                                {{listing_details[0]?.geo?.county}}
                            </div>
                        </div>
                        <div class="attributes">
                            <div class="attribute-name">
                                City
                                
                            </div>
                            <div class="attribute-value">
                                {{listing_details[0]?.address?.city}}
                            </div>
                        </div>
                        <div class="attributes">
                            <div class="attribute-name">
                                Area
                                
                            </div>
                            <div class="attribute-value">
                                {{listing_details[0]?.mls?.area}}
                            </div>
                        </div>
                        <!-- <div class="attributes">
                            <div class="attribute-name">
                                Neighborhood
                                
                            </div>
                            <div class="attribute-value">
                                {{listing_details[0]?.mlsId}}
                            </div>
                        </div> -->
                        <div class="attributes">
                            <div class="attribute-name">
                                Zip
                            </div>
                            <div class="attribute-value">
                                {{listing_details[0]?.address?.postalCode}}
                            </div>
                        </div>
                        <div class="attributes">
                            <div class="attribute-name">
                                Style
                            </div>
                            <div class="attribute-value">
                                {{listing_details[0]?.property?.style}}
                            </div>
                        </div>
                        <div class="attributes">
                            <div class="attribute-name">
                                Year Built
                                
                            </div>
                            <div class="attribute-value">
                                {{listing_details[0]?.property?.yearBuilt}}
                            </div>
                        </div>
                        <div class="attributes">
                            <div class="attribute-name">
                                Taxes
                                
                            </div>
                            <div class="attribute-value">
                                {{listing_details[0]?.tax?.taxAnnualAmount}}
                            </div>
                        </div>
                        <div class="attributes">
                            <div class="attribute-name">
                                Price
                                
                            </div>
                            <div class="attribute-value">
                                {{getPrice(listing_details[0]?.listPrice)}}
                            </div>
                        </div>
                        <div class="attributes">
                            <div class="attribute-name">
                                Bedrooms
                                
                            </div>
                            <div class="attribute-value">
                                {{listing_details[0]?.property?.bedrooms}}
                            </div>
                        </div>
                        <div class="attributes">
                            <div class="attribute-name">
                                Full Bathrooms
                                
                            </div>
                            <div class="attribute-value">
                                {{listing_details[0]?.property?.bathsFull}}
                            </div>
                        </div>
                        <div class="attributes">
                            <div class="attribute-name">
                                Half Bathrooms
                                
                            </div>
                            <div class="attribute-value">
                                {{listing_details[0]?.property?.bathsHalf}}
                            </div>
                        </div>
                        <div class="attributes">
                            <div class="attribute-name">
                                Sqr Footage
                                
                            </div>
                            <div class="attribute-value">
                                {{listing_details[0]?.property?.area}}
                            </div>
                        </div>
                        <div class="attributes">
                            <div class="attribute-name">
                                Lot Size
                                
                            </div>
                            <div class="attribute-value">
                                {{listing_details[0]?.property?.lotSizeArea}}
                            </div>
                        </div>


                        <!-- Property Attributes End Here -->
                        

                    </div>
                    <div class="col-md-7">
                        <p class="the-label-detail">
                            Property Description
                        </p>
                        <p class="property-description">
                            {{listing_details[0]?.remarks}}
                        </p>

                    </div>
                </div>
                <div class="row listing-agent-details">
                    <div class="details">
                        <p class="the-label-detail">
                            Listing provided courtesy of:
                        </p>
                        <p class="property-description">
                            {{listing_details[0]?.agent?.firstName + ' ' + listing_details[0]?.agent?.lastName + ' with ' + listing_details[0]?.office?.name}}                            
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4 details-school">
                        <div class="details">
                            <p class="the-label-detail">
                                Elementary School
                            </p>
                            <p class="property-description">
                                {{listing_details[0]?.school?.elementarySchool}}
                            </p>
                        </div>
                    </div>
                    <div class="col-md-4 details-school">
                        <div class="details">
                            <p class="the-label-detail">
                                Middle School
                            </p>
                            <p class="property-description">
                                {{listing_details[0]?.school?.middleSchool}}                                                                     
                            </p>
                        </div>

                    </div>
                    <div class="col-md-4 details-school">
                        <div class="details">
                            <p class="the-label-detail">
                                High School
                            </p>
                            <p class="property-description">
                                {{listing_details[0]?.school?.highSchool}}                                                                      
                            </p>
                        </div>

                    </div>

                </div>

                <div class="row general-features">
                    <div class="details">
                        <p class="the-label-detail">
                            General Features
                        </p>
                        
                        <div class="attributes">
                            <div class="attribute-name">
                                Construction Materials
                                
                            </div>
                            <div class="attribute-value">
                                {{listing_details[0]?.property?.construction}}
                            </div>
                        </div>
                        <div class="attributes">
                            <div class="attribute-name">
                                Flooring
                                
                            </div>
                            <div class="attribute-value">
                                {{listing_details[0]?.property?.flooring}}
                            </div>
                        </div>
                        <div class="attributes">
                            <div class="attribute-name">
                                HOA Type
                                
                            </div>
                            <div class="attribute-value">
                                {{listing_details[0]?.association?.name}}
                            </div>
                        </div>
                        <div class="attributes">
                            <div class="attribute-name">
                                Interior Features
                                
                            </div>
                            <div class="attribute-value">
                                {{listing_details[0]?.property?.interiorFeatures}}
                            </div>
                        </div>
                        <div class="attributes">
                            <div class="attribute-name">
                                Exterior Features
                                
                            </div>
                            <div class="attribute-value">
                                {{listing_details[0]?.property?.exteriorFeatures}}
                            </div>
                        </div>
                        <div class="attributes">
                            <div class="attribute-name">
                                Heating
                                
                            </div>
                            <div class="attribute-value">
                                {{listing_details[0]?.property?.heating}}
                            </div>
                        </div>
                        
                        <div class="attributes">
                            <div class="attribute-name">
                                Property Type
                            </div>
                            <div class="attribute-value">
                                {{listing_details[0]?.property?.type}}
                            </div>
                        </div>
                        
                    </div>
                </div>


            </div>
            <div class="col-lg-3">
                <button class="btn btn-stride"><i class="fas fa-heart"></i> Save</button>
                <section id="map-property">
                    <agm-map [latitude]='listing_details[0].geo.lat' [longitude]='listing_details[0].geo.lng' [zoom]='16'>
                        <agm-marker [latitude]='listing_details[0].geo.lat' [longitude]='listing_details[0].geo.lng'></agm-marker>
                    </agm-map>
                </section>

                <button class="btn btn-stride" (click)="contactAgent()"><i class="fas fa-envelope"></i> Contact Agent</button>
                <button class="btn btn-stride" (click)="contactAgent()"><i class="fas fa-calculator"></i> Calculate Mortgage</button>
                <button class="btn btn-stride" (click)="contactAgent()"><i class="fas fa-dollar-sign"></i> Calculate Title Costs</button>
                <button class="btn btn-stride" (click)="contactAgent()"><i class="far fa-calendar-alt"></i> Schedule Meeting</button>
                <a class="btn btn-stride"  (click)="contactAgent()"><i class="fas fa-video"></i> Virtual Tour</a>

                
            </div>
            <!-- <div class="cl-md-4 property-details pt-3 pb-3">
                <h3>{{ listing_details[0]?.address.full}}</h3>
            </div>
        [href]="listing_details[0].virtualTourUrl" ~ virtual_tour -->
        </div>
        
    </div>
</section>


<section id="image-gallery">
    <div class="container">
        <h1 class="heading text-center">Gallery</h1>
        <div class="row">
            <div class="col-md-3" *ngFor="let image of images_array.slice(0,4); let i = index">
                <div class="gallery">
                    <img [src]="image.path" class="thumbnail" (click)="showGallery(i)" />
                </div>
            </div>
        </div>
    </div>
</section>
